import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export function MobileEridBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 md:hidden glass-nav border-t border-border px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
      <Link
        to="/auth?mode=signup"
        className="btn-gradient flex min-h-[48px] w-full items-center justify-center gap-2 rounded-xl text-base font-semibold"
      >
        <Zap className="h-5 w-5" aria-hidden="true" />
        Получить ERID
      </Link>
    </div>
  );
}
